<div class="w-100  flex gap-2 justify-between items-center " *ngFor="let i of repeatable">
    <div class="w-100 p-10">
        <div class="p-10 bg-gray-100 skeleton md-mb"></div>
        <div class="p-10 bg-gray-100 skeleton mb-5"></div>
        <div class="p-10 bg-gray-100 skeleton w-20"></div>
    </div>
</div>